import axios from 'axios'
import router from '@/router'

const CRAWLER_CODE = 431
let redirectingCaptcha = false

axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('jwt_token')
  if (token && !config.headers?.Authorization) {
    config.headers = config.headers || {}
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

axios.interceptors.response.use(
  (response) => {
    const code = response?.data?.code
    const url = response?.config?.url || ''
    if (
      code === CRAWLER_CODE &&
      !redirectingCaptcha &&
      !url.includes('/security/captcha/verify') &&
      router.currentRoute.value.path !== '/security/captcha'
    ) {
      redirectingCaptcha = true
      const redirect = router.currentRoute.value.fullPath
      router.push({ path: '/security/captcha', query: { redirect } }).finally(() => {
        redirectingCaptcha = false
      })
    }
    return response
  },
  (error) => Promise.reject(error)
)

export function authHeaders() {
  const token = localStorage.getItem('jwt_token')
  return token ? { Authorization: `Bearer ${token}` } : {}
}

/** 业务错误文案：handler 通用 "Error while handle call" 时改用 info。 */
export function apiErrorText(data, fallback = '请求失败') {
  if (!data) return fallback
  const msg = String(data.message || '').trim()
  const info = String(data.info || '').trim()
  if (msg === 'Error while handle call' && info) return info
  return msg || info || fallback
}

export { CRAWLER_CODE }
